import type { LogLevel } from '@eos/shared-logger-utility/types';
import axios from 'axios';
import Cookies from 'js-cookie';
import { ACTIVITY_ID_COOKIE_KEY } from './activityId';

type LogEntry = {
  message: string;
  level: LogLevel;
  [key: string]: unknown;
};

export const clientLogger = {
  log: (entry: LogEntry) =>
    axios
      .post('/xapp/api/log', {
        ...entry,
        activityId: Cookies.get(ACTIVITY_ID_COOKIE_KEY),
      })
      .catch(() => console.log('Failed to send log')),
};
